// extracted by mini-css-extract-plugin
module.exports = {"slide-item":"slideItem_slide-item__174Zm","item-number":"slideItem_item-number__3pEXq"};